import { createClient } from './supabase/component';

export const logout = async () => {
  const supabase = createClient();
  await supabase.auth.signOut();

  window.location.href = '/';
};
